import { render, staticRenderFns } from "./Zoomable.vue?vue&type=template&id=3a2980dd&scoped=true&"
import script from "./Zoomable.vue?vue&type=script&lang=js&"
export * from "./Zoomable.vue?vue&type=script&lang=js&"
import style0 from "./Zoomable.vue?vue&type=style&index=0&id=3a2980dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2980dd",
  null
  
)

export default component.exports